/* OGs Cart-Drawer Newsletter (Lenny) – delegiert, übersteht Drawer-Re-Render */
(function () {
  if (window.__ogsCartNl) return; window.__ogsCartNl = true;
  var KEY = 'ogsCartNlDone';
  var pending = null;
  function store() { try { return window.sessionStorage; } catch (e) { return null; } }
  function box(form) { return form && form.closest('[data-ogs-cart-nl]'); }
  function msg(form, text, ok) {
    var el = form.querySelector('.ogs-cart-nl__msg'); if (!el) return;
    el.textContent = text || ''; el.className = 'ogs-cart-nl__msg ' + (ok ? 'ogs-cart-nl__msg--ok' : 'ogs-cart-nl__msg--err');
  }
  function busy(form, on) { var b = form.querySelector('.ogs-cart-nl__btn'); if (b) b.disabled = !!on; }
  function done(b) {
    if (!b || b.classList.contains('is-done')) return;
    b.classList.add('is-done'); b.classList.remove('is-collapsed');
    var f = b.querySelector('form'); if (f) msg(f, '', true);
    var ok = b.querySelector('.ogs-cart-nl__ok'); if (ok) ok.hidden = false;
  }
  function applyOpen() {
    var s = store(); if (!s || s.getItem('ogsCartNlOpen') !== '1') return;
    document.querySelectorAll('[data-ogs-cart-nl].is-collapsed').forEach(function (b) { b.classList.remove('is-collapsed'); });
  }
  /* Kompakt-Drawer: "+X weitere Artikel" Hinweis, wenn Artikel unterhalb des sichtbaren Bereichs liegen */
  var moreRaf = 0;
  function updateMore() {
    moreRaf = 0;
    document.querySelectorAll('[data-ogs-more]').forEach(function (m) {
      var sc = m.closest('cart-drawer-items'); if (!sc) { m.hidden = true; return; }
      var r = sc.getBoundingClientRect(); var n = 0;
      if (r.height > 0) sc.querySelectorAll('.cart-item').forEach(function (it) { var ir = it.getBoundingClientRect(); if (ir.bottom > r.bottom + 2) n++; });
      if (!n) { m.hidden = true; return; }
      var t = (n === 1 ? m.getAttribute('data-one') : m.getAttribute('data-other')) || '+{n}';
      var btn = m.querySelector('button'); if (btn) btn.textContent = t.replace('{n}', n);
      m.hidden = false;
    });
  }
  function schedMore() { if (!moreRaf) moreRaf = requestAnimationFrame(updateMore); }
  document.addEventListener('scroll', function (e) { if (e.target && e.target.tagName === 'CART-DRAWER-ITEMS') schedMore(); }, true);
  window.addEventListener('resize', schedMore);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && e.target.closest('#CartDrawer')) schedMore(); }, true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedMore);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.ogs-cart-nl__teaser');
    if (t) {
      var b = t.closest('[data-ogs-cart-nl]'); if (b) b.classList.remove('is-collapsed');
      t.setAttribute('aria-expanded', 'true');
      var s0 = store(); if (s0) s0.setItem('ogsCartNlOpen', '1');
      var inp = b && b.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus(); }, 30);
      schedMore(); return;
    }
    var mb = e.target.closest && e.target.closest('[data-ogs-more] button');
    if (mb) { var sc = mb.closest('cart-drawer-items'); if (sc) sc.scrollBy({ top: Math.max(120, sc.clientHeight * 0.8), behavior: 'smooth' }); }
  });
  function applyDone() {
    applyOpen(); schedMore(); setTimeout(schedMore, 400); setTimeout(schedMore, 1200);
    var s = store(); if (!s || s.getItem(KEY) !== '1') return;
    document.querySelectorAll('[data-ogs-cart-nl]').forEach(done);
  }
  function frame() {
    var f = document.querySelector('iframe[name="ogs-nl-frame"]');
    if (!f) {
      f = document.createElement('iframe'); f.name = 'ogs-nl-frame'; f.title = 'newsletter';
      f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1;
      f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      document.body.appendChild(f);
    }
    if (!f.__ogsBound) {
      f.__ogsBound = true;
      f.addEventListener('load', function () {
        if (!pending) return;
        var form = document.getElementById('OgsCartNewsletter') || pending.form;
        var b = box(form), url = '';
        try { url = f.contentWindow.location.href || ''; } catch (e) { url = ''; }
        clearTimeout(pending.timer); var p = pending; pending = null;
        if (url.indexOf('/challenge') !== -1) {
          /* Shopify-Bot-Schutz verlangt eine sichtbare Bestätigung: normal absenden */
          form.removeAttribute('target'); form.submit(); return;
        }
        busy(form, false);
        if (url.indexOf('customer_posted=true') !== -1) {
          var s = store(); if (s) s.setItem(KEY, '1');
          done(b);
          try { document.dispatchEvent(new CustomEvent('ogs:newsletter-subscribed', { detail: { source: 'cart-drawer' } })); } catch (e) {}
        } else {
          msg(form, b && b.getAttribute('data-msg-err'), false);
        }
      });
    }
    return f;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'OgsCartNewsletter') return;
    var b = box(form), email = form.querySelector('input[type=email]');
    if (!email || !email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      e.preventDefault(); e.stopImmediatePropagation();
      msg(form, b && b.getAttribute('data-msg-invalid'), false); return;
    }
    frame(); form.setAttribute('target', 'ogs-nl-frame');
    busy(form, true); msg(form, '', true);
    if (pending) clearTimeout(pending.timer);
    /* Kein Fehler per Timeout: Shopify-hCaptcha kann eine Bestätigung verlangen, das dauert. Button nur wieder freigeben. */
    pending = { form: form, timer: setTimeout(function () { busy(form, false); }, 15000) };
  }, true);
  /* Code antippen = kopieren */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-ogs-copy]'); if (!c) return;
    var code = c.getAttribute('data-ogs-copy'), hint = c.querySelector('.ogs-cart-nl__code-hint');
    function ok() { if (hint) hint.textContent = c.getAttribute('data-copied') || '✓'; }
    try { navigator.clipboard.writeText(code).then(ok, function () {}); } catch (err) {}
  });
  function init() {
    /* Rückkehr nach Shopify-hCaptcha-Challenge (voller Seitenwechsel): Erfolg merken und Drawer mit Code öffnen */
    try {
      if (/[?&]customer_posted=true/.test(location.search) && location.hash === '#OgsCartNewsletter') {
        var s0 = store(); if (s0) s0.setItem(KEY, '1');
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function' && !cd.classList.contains('is-empty')) setTimeout(function () { try { cd.open(); } catch (e) {} }, 300);
      }
    } catch (e) {}
    frame(); applyDone();
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(applyDone).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (d) d.addEventListener('transitionend', schedMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
